import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { CarouselModule, MediaModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomProductService } from '../../../service/product/custom-product.service';
import { SlickCarouselUtilService } from '../../../utility/slick-carousel.util';
import { PromotionalTextModule } from '../promotional-text/promotional-text.module';
import { TooltipIconModule } from '../tooltip-icon/tooltip-icon.module';
import { ProductCarouselBigComponent } from './product-carousel-big.component';
import { ProductCarouselNormalComponent } from './product-carousel-normal.component';
import { ProductCarouselComponent } from './product-carousel.component';

@NgModule({
  imports: [
    CommonModule,
    MediaModule,
    CarouselModule,
    RouterModule,
    UrlModule,
    I18nModule,
    SlickCarouselModule,
    TooltipIconModule,
    PromotionalTextModule,
    SharedModule,
    ProductCarouselComponent,
    ProductCarouselNormalComponent,
    ProductCarouselBigComponent,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ShimanoProductCarouselComponent: {
          component: ProductCarouselComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
        ShimanoRecentlyViewedComponent: {
          component: ProductCarouselComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
    CustomProductService,
    SlickCarouselUtilService,
  ],
})
export class ProductCarouselModule {}
